import { MHTTPCL, JSON_STRING, HttpClient } from "../../../services/http/http-client";
import { SETTINGS_URL } from "../../../services/common-urls";

export const AccountingSettingsService = {
  findAccountingTabDetails: () => MHTTPCL.get(SETTINGS_URL, {
    section: 'settings',
    action: 'settings_accounting_settings_accounting_settings',
    output: JSON_STRING,
  }),
  findTaxTabDetails: () => MHTTPCL.get(SETTINGS_URL, {
    section: 'settings',
    action: 'settings_accounting_settings_taxes_settings',
    output: JSON_STRING,
  }),
  findMoneyAccountDetails: ({
    money_account_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'settings',
    action: 'edit_money_account',
    money_account_id,
    output: JSON_STRING,
  }),
  findCostGroupDetails: ({
    cost_group_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'settings',
    action: 'edit_product_type_form',
    output: JSON_STRING,
    cost_group_id,
  }),
  addCostGroupDetails: () => HttpClient.post(SETTINGS_URL, {
    section: 'settings',
    action: 'add_cost_group_form',
    output: JSON_STRING,
  }),
  findChannelDetails: ({
    channel_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'settings',
    action: 'edit_channel_form',
    output: JSON_STRING,
    channel_id,
  }),
  findTaxTypeDetails: ({
    tax_type_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'settings',
    action: 'edit_tax_type',
    output: JSON_STRING,
    tax_type_id,
  }),

  //..............................................................................
  loadDefaultVatEntries:()=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action	:"load_default_vat_entries",
    output: JSON_STRING
  }),
  
  euOneStopTaxesTab:()=>MHTTPCL.post(SETTINGS_URL,{
    section	: "settings",
    action	: "eu_one_stop_taxes_tab",
    output: JSON_STRING
  }),
  getFormatsWithVatCategory:()=>MHTTPCL.post(SETTINGS_URL,{
    section	: "settings",
    action	:"get_formats_with_vat_category",
    output: JSON_STRING
  }),

  // vat category
  deleteVatCategory:(vat_category_id)=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action	:"delete_vat_category",
    vat_category_id:vat_category_id
  }),

  getVatCategory:({vat_category_id})=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action	:"get_vat_category",
    vat_category_id	:vat_category_id
  }),

  saveVatCategory:({vat_category_id="",vat_category_name})=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action:	"save_vat_category",
    vat_category_id:	vat_category_id,
    vat_category_name:	vat_category_name
  }),





  //vat territory
  saveVatTterritory:({vat_territory,vat_territory_name,start_date})=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action	:"save_vat_territory",
    vat_territory	:vat_territory,
    vat_territory_name	:vat_territory_name,
    start_date	:start_date
  }),

  deleteVatTerritory:(vat_territory_id)=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action	:"delete_vat_territory",
    vat_territory_id:vat_territory_id
  }),

  vatTerritoryEditModalData:(vat_territory_id)=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action	:"vat_territory_edit_modal_data",
    vat_territory_id:vat_territory_id
  }),

  addVatRate:(vat_territory)=>MHTTPCL.post(SETTINGS_URL,{
    section	: "settings",
    action	:"add_vat_rate",
    vat_territory	:vat_territory
  }),

  deleteVatRate:(vat_rate_id)=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action	:"delete_vat_rate",
    vat_rate_id:vat_rate_id
  }),

  addVatClass:(vat_territory)=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action	:"add_vat_class",
    vat_territory	:vat_territory
  }),

  deleteVatClass:(vat_class_id)=>MHTTPCL.post(SETTINGS_URL,{
    section	: "settings",
    action	: "delete_vat_class",
    vat_class_id	: vat_class_id
  }),

  modifyRecord:(kVal,vat_class_name,vat_class)=>MHTTPCL.post(SETTINGS_URL,{
    modify_type	:"record",
    table	:"vat_rates",
    kVal :	kVal,
    vat_class_name:	vat_class_name,
    vat_class	:vat_class
  }),

  vatEntryCount:()=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action	:"vat_entry_count",
    output:JSON_STRING
  }),

  aiUpdateFeatureProp:(feature_name, property_name, property_val)=>MHTTPCL.post(SETTINGS_URL,{
    section	:"settings",
    action	:"ai_update_feature_prop",
    feature_name,
    property_name,
    property_val
  })






  // section=settings&action=open_vat_report&date=2022-06-01
}